import { ImageCarousel } from '@/components/ui/images/image-carousel/ImageCarousel';
import { ModalImage } from '@/components/ui/overlays/modal-image/ModalImage';

export const LargeCarouselImageItem = ({ data }) => {
	const src = data?.fields?.large_img_highlight;
	const alt = data?.fields?.alt_img;
	const sizes = {
		width: data?.fields?.sizes?.width,
		height: data?.fields?.sizes?.height,
	};
	const zoomEnabled = data?.fields?.enable_image_zoom === '1';

	return (
		<ModalImage src={src} alt={alt} zoomEnabled={zoomEnabled}>
			<ImageCarousel src={src} alt={alt} sizes={sizes} />
		</ModalImage>
	);
};
